export const packages = {
  venue: {
    slug: 'venue-packages',
    ids: ['basic', 'platinum'],
    prices: ['congress', 'exhibition'],
    rights: [
      {
        id: 'rfp',
        scopes: [1, 2],
        rights: [],
      },
      {
        id: 'rur',
        scopes: [2],
        rights: [],
      },
      {
        id: 'vi',
        rights: [
          { id: 'vi1', scopes: [0, 1, 2] },
          { id: 'vi2', scopes: [0, 1, 2] },
          { id: 'vi3', scopes: [0, 1, 2] },
          { id: 'vi4', scopes: [0, 1, 2] },
          { id: 'vi5', scopes: [0, 1, 2] },
          { id: 'vi6', scopes: [1, 2] },
          { id: 'vi7', scopes: [2] },
          { id: 'vi8', scopes: [1, 2] },
          { id: 'vi9', scopes: [1, 2] },
          { id: 'vi10', scopes: [0, 1, 2] },
          { id: 'vi11', scopes: [1, 2] },
          { id: 'vi12', scopes: [1, 2] },
        ],
      },
      {
        id: 'eic',
        rights: [
          { id: 'eic1', scopes: [0, 1, 2] },
          { id: 'eic2', scopes: [0, 1, 2] },
          { id: 'eic3', scopes: [1, 2] },
          { id: 'eic4', scopes: [1, 2] },
          { id: 'eic5', scopes: [1, 2] },
          { id: 'eic6', scopes: [2] },
        ],
      },
      {
        id: 'cic',
        rights: [
          { id: 'cic1', scopes: [0, 1, 2] },
          { id: 'cic2', scopes: [0, 1, 2] },
          { id: 'cic3', scopes: [0, 1, 2] },
          { id: 'cic4', scopes: [1, 2] },
          { id: 'cic5', scopes: [1, 2] },
          { id: 'cic6', scopes: [1, 2] },
          { id: 'cic7', scopes: [1, 2] },
          { id: 'cic8', scopes: [1, 2] },
          { id: 'cic9', scopes: [1, 2] },
          { id: 'cic10', scopes: [2] },
        ],
      },
      {
        id: 'ori',
        rights: [
          { id: 'ori1', scopes: [1, 2] },
          { id: 'ori2', scopes: [1, 2] },
          { id: 'ori3', scopes: [2] },
        ],
      },
      {
        id: 'ela',
        rights: [
          { id: 'ela1', scopes: [1, 2] },
          { id: 'ela2', scopes: [1, 2] },
          { id: 'ela3', scopes: [1, 2] },
          { id: 'ela4', scopes: [1, 2] },
          { id: 'ela5', scopes: [1, 2] },
        ],
      },
      {
        id: 'spl',
        rights: [{ id: 'spl1', scopes: [1, 2] }],
      },
      {
        id: 'md',
        rights: [
          { id: 'md1', scopes: [2] },
          { id: 'md2', scopes: [2] },
          { id: 'md3', scopes: [2] },
        ],
      },
    ],
  },
  service: {
    slug: 'service-provider-package',
    ids: ['service-provider'],
    prices: [
      'onecity',
      'fivecities',
      'tencities',
      'twentycities',
      'thirtycities',
    ],
    rights: [
      {
        id: 'location',
        scopes: [0],
        rights: [],
      },
      {
        id: 'description',
        scopes: [0],
        rights: [],
      },
      {
        id: 'contact',
        scopes: [0],
        rights: [],
      },
      {
        id: 'services-list',
        scopes: [0],
        rights: [],
      },
      {
        id: 'services-desc',
        scopes: [0],
        rights: [],
      },
      {
        id: 'rfp',
        scopes: [0],
        rights: [],
      },
      {
        id: 'rur',
        scopes: [0],
        rights: [],
      },
      {
        id: 'docs',
        scopes: [0],
        rights: [],
      },
      {
        id: 'av',
        scopes: [0],
        rights: [],
      },
    ],
  },
} as any;
